import { FC, useEffect } from "react";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";

import { BAND_PATHS } from "Bands/router";
import {
  useClearActionMetaOnUnMount,
  useCompanyRoute,
  useInvalidVATError,
} from "Bands/utils";
import { BackButton, Card } from "shared/components";
import { Spacer } from "shared/layout";
import { CenterContent, MainContent } from "shared/styles";
import { copy } from "shared/assets";
import { Company } from "shared/assets/icons";
import { BillingForm } from "Bands/containers";
import { useCompanyContext } from "Bands/contexts";
import { BAND_ACTIONS, ICompanyPatchData } from "Bands/types";
import { dataMetaSelector, editCompany } from "Bands/state";
import { IAPIState, IStatus } from "shared/types";
import { addTemporaryToast } from "shared/components/Toast";

const editCopy = copy.companyInfo.edit;

export const EditCompanyInfo: FC = () => {
  const history = useHistory();
  const { getPath, pushRoute } = useCompanyRoute();
  const { company, companyId } = useCompanyContext();

  const dispatch = useDispatch();
  const { api: apiMeta } = useSelector(
    dataMetaSelector(BAND_ACTIONS.editCompany)
  );
  useClearActionMetaOnUnMount(BAND_ACTIONS.editCompany);

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      dispatch(
        addTemporaryToast({
          status: IStatus.success,
          message: editCopy.success,
        })
      );

      pushRoute(BAND_PATHS.COMPANY_INFO);
    }
  }, [apiMeta?.status, dispatch, pushRoute]);

  const handleSubmit = (companyData: ICompanyPatchData) => {
    if (!companyId) return;

    dispatch(
      editCompany({
        companyId,
        companyData,
      })
    );
  };

  const { error } = useInvalidVATError(BAND_ACTIONS.editCompany);

  if (!company) {
    history.push(BAND_PATHS.HOME);
    return null;
  }

  return (
    <CenterContent>
      <MainContent>
        <Spacer size="m">
          <BackButton
            to={getPath(BAND_PATHS.COMPANY_INFO)}
            label={editCopy.back}
          />
          <Card icon={Company} title={editCopy.title}>
            <BillingForm
              defaultValues={company}
              handleSubmit={handleSubmit}
              buttons={{
                primary: true,
                secondary: {
                  onClick: () => pushRoute(BAND_PATHS.COMPANY_INFO),
                },
              }}
              apiStatus={apiMeta?.status}
              error={error}
              apiError={apiMeta?.error}
            />
          </Card>
        </Spacer>
      </MainContent>
    </CenterContent>
  );
};
